import { css } from 'aphrodite';
import * as React from 'react';
import { ActiveGoogleBusinessReview } from '.';
import { getRatingIntFromText } from '../../../../models/UiUtils';
import { useFullscreenModal, useUserSession } from '../../../../models/hooks/appStateHooks';
import { Button } from '../../Button';
import { styleSheet } from './styles';

interface ReviewActionsProps {
	activeReview: ActiveGoogleBusinessReview;
	userIsAdmin: boolean;
	onPostResponse: () => void;
	hasReply?: boolean;
}

export const ReviewActions: React.FC<ReviewActionsProps> = ({
	activeReview,
	userIsAdmin,
	onPostResponse,
	hasReply,
}) => {
	const fullscreenModal = useFullscreenModal();
	const userSession = useUserSession();

	const handleShareToSocial = React.useCallback(() => {
		fullscreenModal.history.push('/testimonial-image-editor', {
			testimonialSource: {
				type: 'google_review',
				data: activeReview,
			},
			model: {
				content: activeReview?.text || '',
				campaignName: activeReview?.author ? `Review from ${activeReview.author}` : 'Google Review',
			},
		});
	}, [activeReview, fullscreenModal.history]);

	const rating = getRatingIntFromText(activeReview?.rating);
	const isFiveStarRating = rating === 5;
	const hasBeenPostedToSocial = activeReview?.associatedSocialPostId;

	const showPostResponse = !hasReply && userIsAdmin;
	const showShareToSocial =
		isFiveStarRating &&
		!hasBeenPostedToSocial &&
		userSession?.account?.features?.socialMedia?.enabled &&
		userSession?.user?.userGroupPermissions?.featurePermissions?.socialMedia?.send;

	if (!showPostResponse && !showShareToSocial) {
		return null;
	}

	return (
		<div>
			<div className={css(styleSheet.buttonContainer)}>
				{showPostResponse && (
					<Button onClick={onPostResponse} kind='reverse' size='small'>
						Post a response
					</Button>
				)}
				{showShareToSocial && (
					<Button onClick={handleShareToSocial} kind='reverse' size='small'>
						Create Social Post
					</Button>
				)}
			</div>
		</div>
	);
};
